module.exports = __webpack_public_path__ + "static/media/point.a7f026e6.png";